import React from 'react';
import { SimpleHairline, HairlineGroup, StyledHeading } from './styled';

const Hairline = ({icon, title, compact, main, fat}) => {
  if (icon || title) {
    const Icon = icon;
    return (
      <HairlineGroup>
        <SimpleHairline />
        <div>
          {icon && (
            <Icon size={compact ? 'medium' : 'large'} />
          )}
          <StyledHeading level='1'>
            {title}
          </StyledHeading>
        </div>
        <SimpleHairline />
      </HairlineGroup>
    );
  } 

  return (
    <SimpleHairline main={main} fat={fat} />
  );
};

export default Hairline;



// WEBPACK FOOTER //
// ./src/elements/Hairline/Hairline.jsx